/**
 * Formats vehicle make selection display text
 * @param {Array} selectedMakes - Array of selected vehicle make objects with _id and name properties
 * @param {number} maxDisplay - Maximum number of makes to show before showing "+X more" (default: 1)
 * @returns {string} Formatted display string
 *
 * Examples:
 * - Single selection: "Audi"
 * - Multiple selections: "Audi +2 more"
 * - Empty array: ""
 */
export const formatVehicleMakeDisplay = (selectedMakes = [], maxDisplay = 1) => {
    if (!selectedMakes || selectedMakes.length === 0) {
        return '';
    }

    if (selectedMakes.length === 1) {
        return selectedMakes[0]?.name || '';
    }

    if (selectedMakes.length <= maxDisplay) {
        return selectedMakes.map((make) => make?.name).join(', ');
    }

    // Show first make + count of remaining
    const firstMake = selectedMakes[0]?.name || '';
    const remainingCount = selectedMakes.length - maxDisplay;
    return `${firstMake} +${remainingCount} more`;
};

/**
 * Gets the count of selected vehicle makes
 * @param {Array} selectedMakes - Array of selected vehicle make objects
 * @returns {number} Count of selected makes
 */
export const getVehicleMakeCount = (selectedMakes = []) => {
    return selectedMakes?.length || 0;
};

/**
 * Checks if vehicle makes are selected
 * @param {Array} selectedMakes - Array of selected vehicle make objects
 * @returns {boolean} True if any makes are selected
 */
export const hasVehicleMakesSelected = (selectedMakes = []) => {
    return selectedMakes && selectedMakes.length > 0;
};
